import l, { forwardRef as c } from "react";
import { P as a } from "./index-CZzwT3Oj.mjs";
function f() {
  return f = Object.assign || function(e) {
    for (var o = 1; o < arguments.length; o++) {
      var r = arguments[o];
      for (var t in r)
        Object.prototype.hasOwnProperty.call(r, t) && (e[t] = r[t]);
    }
    return e;
  }, f.apply(this, arguments);
}
function u(e, o) {
  if (e == null) return {};
  var r = y(e, o), t, n;
  if (Object.getOwnPropertySymbols) {
    var i = Object.getOwnPropertySymbols(e);
    for (n = 0; n < i.length; n++)
      t = i[n], !(o.indexOf(t) >= 0) && Object.prototype.propertyIsEnumerable.call(e, t) && (r[t] = e[t]);
  }
  return r;
}
function y(e, o) {
  if (e == null) return {};
  var r = {}, t = Object.keys(e), n, i;
  for (i = 0; i < t.length; i++)
    n = t[i], !(o.indexOf(n) >= 0) && (r[n] = e[n]);
  return r;
}
var s = c(function(e, o) {
  var r = e.color, t = r === void 0 ? "currentColor" : r, n = e.size, i = n === void 0 ? 24 : n, p = u(e, ["color", "size"]);
  return /* @__PURE__ */ l.createElement("svg", f({
    ref: o,
    xmlns: "http://www.w3.org/2000/svg",
    width: i,
    height: i,
    viewBox: "0 0 24 24",
    fill: "none",
    stroke: t,
    strokeWidth: "2",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }, p), /* @__PURE__ */ l.createElement("line", {
    x1: "18",
    y1: "6",
    x2: "6",
    y2: "18"
  }), /* @__PURE__ */ l.createElement("line", {
    x1: "6",
    y1: "6",
    x2: "18",
    y2: "18"
  }));
});
s.propTypes = {
  color: a.string,
  size: a.oneOfType([a.string, a.number])
};
s.displayName = "X";
export {
  s as X
};
